/**
 * 部署
 */
export class Section {
    /** 部署コード */
    code = ""
    /** 部署名 */
    name = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Section>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Section(JSON.parse(JSON.stringify(this)));
    }

}
